import { render, staticRenderFns } from "./TreeViewGroup.vue?vue&type=template&id=1009f592&scoped=true&"
import script from "./TreeViewGroup.vue?vue&type=script&lang=ts&"
export * from "./TreeViewGroup.vue?vue&type=script&lang=ts&"
import style0 from "./TreeViewGroup.vue?vue&type=style&index=0&id=1009f592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1009f592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VIcon,VSpacer,VTooltip})
